export default "__VITE_ASSET__ClQfFZqF__"